<template>
  <v-card flat class="mb-2 py-2">
    <v-layout row align-center>
      <img class="icon ml-2 mr-4"
           src="@/assets/image/application/invoice.svg"
           alt="Ícone de Boleto"
           style="width: 32px"/>

      <v-layout column align-start>
        <div v-if="!isPaymentSlipPending">
          <v-btn small outline color="primary" class="ml-0 mb-1" active-class
                 v-if="!isPaymentSlipExpired && !isPaymentSlipPaid"
                 :href="payment_slip.file.url" target="_blank">
            Visualizar
          </v-btn>
          <v-btn small flat color="primary" class="ml-0 mb-1" active-class
                 v-on:click="warningDuplicatePaymentSlip = true"
                 v-if="isPaymentSlipExpired && !isPaymentSlipPaid">
            Gerar 2ª via
          </v-btn>
        </div>
        <small class="badge amber" v-if="isPaymentSlipPending">
          Boleto não disponível
        </small>
        <small class="badge green" v-else-if="isPaymentSlipPaid && payment_slip.value > 0">
          Boleto Pago
        </small>
        <small class="badge green" v-else-if="isPaymentSlipPaid && payment_slip.value === 0">
          Boleto Dispensado
        </small>
        <small class="badge red" v-else-if="isPaymentSlipExpired && !isPaymentSlipPaid">
          DAR {{payment_slip.processing_number}} Vencido
        </small>

        <small
          class="badge amber"
            v-else-if="!isPaymentSlipPaid && !isPaymentSlipPending &&!isPaymentSlipExpired"
        >
          Vence em {{ moment(payment_slip.due_date,'YYYY-MM-DD').format('DD/MM/YYYY')}}
        </small>

        <v-btn
          small
          color="primary"
          v-if="isAdmin && !isPaymentSlipPaid && !isPaymentSlipPending"
          @click="buttonUpdatePaymentSlip(payment_slip.processing_number)"
        >
          Atualizar para pago
        </v-btn>

      </v-layout>

    </v-layout>
    <v-dialog v-model="warningDuplicatePaymentSlip" width="500">
      <v-card>
        <v-card-title class="headline green white--text" primary-title>
          Gerar 2º via do Boleto
        </v-card-title>

        <v-card-text>
          <h3 class="text-xs-center">Atenção!</h3>

          <p>Caso você já tenha realizado o pagamento do boleto, aguarde até o sistema realizar a
            compensação.</p>
          <p>A compensação poderá levar entre 12h a 48h dependendo do horário e do banco em que
            o boleto foi pago e é feita de forma automatizada pelo sistema.</p>
          <p>Se, após esse período, o boleto ainda não foi compensado, entre em contato com
            o atendimento unificado clicando no círculo de interrogação abaixo informando o
            número do DAR.</p>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="warningDuplicatePaymentSlip = false">Cancelar</v-btn>
          <v-btn color="primary"
                 flat
                 @click="reEmissionPaymentSlip(payment_slip.processing_number)">
            Gerar 2ª Via
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from 'moment';
import { isEmpty } from 'lodash'; 
import ApplicationService from '@/services/applications/ApplicationService';

export default {
  name: 'BoletoCard',
  props: ['payment_slip'],
  data() {
    return {
      moment,
      isEmpty,
      warningDuplicatePaymentSlip: false,
    };
  },
  methods: {
    reEmissionPaymentSlip(processingNumber) {
      this.$store.dispatch('setLoadingDialog', true);
      ApplicationService
        .reEmissionPaymentSlip(processingNumber)
        .then(() => {
          this.$swal({
            type: 'success',
            titleText: '2ª via do boleto gerado com sucesso!',
          });
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            titleText: 'Erro ao gerar 2ª via do boleto',
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    buttonUpdatePaymentSlip(processingNumber) {
      this.$store.dispatch('setLoadingDialog', true);
      ApplicationService
        .updatePaymentSlipStatus(processingNumber)
        .then(() => {
          this
            .$store
            .dispatch('adminFetchApplication', this.$route.params.id);

          this.$swal({
            type: 'success',
            titleText: 'Status do boleto atualizado para Pago',
          });
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            titleText: 'Não foi possível atualizar o status do boleto. Tente novamente em alguns instantes',
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
  computed: {
    hasPaymentSlips() {
      return !this.isEmpty(this.payment_slip);
    },
    isPaymentSlipExpired() {
      const currentDate = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`;
      return this.hasPaymentSlips &&
        moment(this.payment_slip.due_date).isBefore(currentDate);
    },
    isPaymentSlipPaid() {
      return this.hasPaymentSlips && this.payment_slip.payment_status;
    },
    isPaymentSlipPending() {
      return !this.hasPaymentSlips || this.payment_slip.pending;
    },
    isAdmin() {
      return this.$router.currentRoute.meta.userAlias === 'admin';
    },
  },
};
</script>
